module.exports = __webpack_public_path__ + "static/logo-2cc560c2ac11bd6988bbedabfe29f021.png";